import { Button, Dialog } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import ComponentToPrintSVG from './molecules/ComponentToPrintSVG';
import { DialogTitle, DialogContent, DialogActions, ProductomodalContainer } from './productosComponents';

function LabelPrinterModal({ data, modal, handleClose }) {
  const codigoRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => codigoRef.current,
  });
	
  return (
    <Dialog maxWidth="md" onClose={handleClose} open={modal}>
      <DialogTitle id='customized-dialog-title' onClose={handleClose}>
       Imprimir etiquetas
      </DialogTitle>

      <DialogContent dividers>
        <ProductomodalContainer>
        <ComponentToPrintSVG details={data} ref={codigoRef} />
        </ProductomodalContainer>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" component="span" onClick={handlePrint}>
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  );
}

LabelPrinterModal.propTypes = {
  modal: PropTypes.bool,
  data: PropTypes.array.isRequired,
  handleClose: PropTypes.func
};

export default LabelPrinterModal;



